import React from 'react';
import {useSelector} from 'react-redux';
import Table from '@ey/motif-react-wrapper/Table';
import EllipsesControl from '../../../Common/EllipsesControl/EllipsesControl';
import {
	labels,
	workspaceThresholdPercentage,
	workSpaceStatusEnum
} from '../../../../util/uiconstants';
import Wrapper from '../Styles/sharepointWorkspacesbasestyle';
import MotifTableHeaderRenderer from '@ey/motif-react-wrapper/TableHeaderRenderer';
import {compareNumericStrings} from '../../common/util';

function WorkSpacesDetails() {
	const collaborationWorkspaces = useSelector(
		(store) => store.workSpaceDetails.collaborationWorkspaces
	);

	const getRowStyle = (params) => ({
		background:
			params.node.rowIndex % 2 === 0
				? 'var(--neutrals-00white)'
				: 'var(--ui-background-secondary)'
	});

	const columnDefs = [
		{
			minWidth: 50,
			width: 50,
			flex: 6,
			headerName: labels.workspaceName,
			field: 'workspaceName', // should be same as the property name in the data, else sorting will not work
			cellRenderer: (params) => workSpaceNameCellRenderer(params),
			lockPosition: true,
			suppressSizeToFit: true,
			headerComponentParams: {
				label: labels.workspaceName,
				enableSorting: true,
				showFilter: false,
				enableMenu: false
			}
		},
		{
			minWidth: 25,
			width: 25,
			flex: 4,
			headerName: labels.engagementCount,
			field: 'documentCount',
			cellRenderer: (params) => documentCountCellRenderer(params),
			lockPosition: true,
			suppressSizeToFit: true,
			headerComponentParams: {
				label: labels.engagementCount,
				enableSorting: true,
				showFilter: false,
				enableMenu: false
			},
			comparator: compareNumericStrings
		},
		{
			minWidth: 25,
			width: 25,
			flex: 4,
			headerName: labels.percentCapacity,
			field: 'consumedCapacityPercentage',
			cellRenderer: (params) => consumedCapacityCellRenderer(params),
			lockPosition: true,
			suppressSizeToFit: true,
			headerComponentParams: {
				label: labels.percentCapacity,
				enableSorting: true,
				showFilter: false,
				enableMenu: false
			},
			comparator: compareNumericStrings
		},
		{
			minWidth: 25,
			width: 25,
			flex: 4,
			headerName: labels.status,
			field: 'status',
			cellRenderer: (params) => statusCellRenderer(params),
			lockPosition: true,
			suppressSizeToFit: true,
			headerComponentParams: {
				label: labels.status,
				enableSorting: true,
				showFilter: false,
				enableMenu: false
			}
		},
		{
			minWidth: 25,
			width: 25,
			flex: 4,
			headerName: labels.statusChangeLabel,
			field: 'statusChangeDate',
			cellRenderer: (params) => statusChangeCellRenderer(params),
			lockPosition: true,
			suppressSizeToFit: true,
			headerComponentParams: {
				label: labels.statusChangeLabel,
				enableSorting: true,
				showFilter: false,
				enableMenu: false
			}
		}
	];

	const workSpaceNameCellRenderer = (e) => {
		return (
			<section className="roleType motif-body2-default-light">
				<EllipsesControl
					content={e.data.workspaceName}
					tooltip={e.data.workspaceName}
					noOfLines={1}
					ellipsisClass="columnName"
				/>
			</section>
		);
	};

	const documentCountCellRenderer = (e) => {
		return (
			<section className="roleType motif-body2-default-light">
				{e.data.documentCount || '-'}
			</section>
		);
	};

	const consumedCapacityCellRenderer = (e) => {
		const className = `roleType motif-body2-default-light ${
			e.data.consumedCapacityPercentage > workspaceThresholdPercentage
				? 'warning'
				: ''
		}`;

		return (
			<section className={className}>
				{e.data.consumedCapacityPercentage !== null
					? `${e.data.consumedCapacityPercentage}%`
					: '-'}
			</section>
		);
	};

	const statusCellRenderer = (e) => {
		const className = `roleType motif-body2-default-light ${
			e.data.statusId === workSpaceStatusEnum.PENDING ||
			e.data.statusId === workSpaceStatusEnum.ERROR
				? 'warning'
				: ''
		}`;

		return <section className={className}>{e.data.status}</section>;
	};

	const statusChangeCellRenderer = (e) => {
		return (
			<section className="roleType motif-body2-default-light">
				{e.data.statusChangeDate}
			</section>
		);
	};

	return (
		<Wrapper>
			<section className="mainwrapper">
				{collaborationWorkspaces.length > 0 ? (
					<section className="workspace_menuTable mainResponsiveWrapper">
						<section className="managepermissionTable">
							<Table
								defaultColDef={{
									flex: 1,
									sortable: true,
									filter: false,
									resizable: false,
									minWidth: 180,
									lockPosition: true
								}}
								components={{agColumnHeader: MotifTableHeaderRenderer}}
								onGridReady={(params) => {
									params.api.sizeColumnsToFit();
								}}
								getRowStyle={getRowStyle}
								rowHeight={32}
								headerHeight={32}
								enableCellTextSelection={true}
								columnDefs={columnDefs}
								rowData={collaborationWorkspaces}
								rowBuffer={50}
							/>
						</section>
					</section>
				) : (
					<section className="norecord">{labels.noResultsFound}</section>
				)}
			</section>
		</Wrapper>
	);
}

export default WorkSpacesDetails;
